var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import FieldWrap from '../FieldWrap/FieldWrap';

var CheckboxComponent = function CheckboxComponent(_ref) {
  var name = _ref.name,
      label = _ref.label,
      displayNotes = _ref.displayNotes,
      validate = _ref.validate;
  var customLabel = React.createElement('a', {
    target: '_blank',
    href: displayNotes
  }, label);
  return React.createElement('div', {
    className: 'form-group mtop-30'
  }, React.createElement(Field, {
    type: 'checkbox',
    name: name,
    label: customLabel,
    validate: validate,
    component: FieldComponent
  }));
};

var FieldComponent = function FieldComponent(_ref2) {
  var input = _ref2.input,
      meta = _ref2.meta,
      label = _ref2.label,
      displayNotes = _ref2.displayNotes;
  return React.createElement(FieldWrap, {
    meta: meta,
    displayNotes: displayNotes
  }, React.createElement(Checkbox, _extends({
    input: input
  }, input, {
    label: label
  })));
};

CheckboxComponent.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.array.isRequired,
  label: PropTypes.element.isRequired,
  displayNotes: PropTypes.string
};
export default CheckboxComponent;